module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('address-blank-form', {
    attrs: {
      "submit-label": "Добавить адрес",
      "address": _vm.address,
      "errors": _vm.errors,
      "form-type": "add"
    },
    on: {
      "submit": _vm.processAddressForm
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-576a210e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/address/AddressAddForm.vue
// module id = 650
// module chunks = 0